import { Stack } from '@chakra-ui/react';

export default function ExchangeContainer({ children }: { children: React.ReactNode }) {
  return (
    <Stack
      paddingTop={4}
      width="full"
      minHeight="fit-content"
      transition="all 0.3s ease-in-out"
      transform="translateY(0)"
      opacity={1}
      animation="slideIn 0.3s ease-in-out"
      sx={{
        '@keyframes slideIn': {
          '0%': {
            transform: 'translateY(-20px)',
            opacity: 0,
          },
          '100%': {
            transform: 'translateY(0)',
            opacity: 1,
          },
        },
      }}
    >
      {children}
    </Stack>
  );
}
